import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "label", "checkbox", "icon"]

  connect() {
    this.updateLabel()
    
    // Close when clicking outside
    this.externalClickListener = (e) => {
      if (!this.element.contains(e.target)) {
        this.close()
      }
    }
    document.addEventListener("click", this.externalClickListener)
  }

  disconnect() {
    document.removeEventListener("click", this.externalClickListener)
  }

  toggle() {
    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    if (this.hasIconTarget) this.iconTarget.classList.add("rotate-180")
    // Use timeout to ensure display: block is applied before opacity transition
    setTimeout(() => {
      this.menuTarget.classList.remove("opacity-0", "translate-y-2")
    }, 10)
  }

  close() {
    if (this.hasIconTarget) this.iconTarget.classList.remove("rotate-180")
    this.menuTarget.classList.add("opacity-0", "translate-y-2")
    // Wait for transition
    setTimeout(() => {
      this.menuTarget.classList.add("hidden")
    }, 200)
  }

  updateLabel() {
    const selectedCount = this.checkboxTargets.filter(c => c.checked).length
    if (selectedCount === 0) {
      this.labelTarget.textContent = "Select options..."
      this.labelTarget.classList.add("text-gray-400")
      this.labelTarget.classList.remove("text-blue-600")
    } else {
      this.labelTarget.textContent = `${selectedCount} selected`
      this.labelTarget.classList.remove("text-gray-400")
      this.labelTarget.classList.add("text-blue-600")
    }
  }

  handleCheck(event) {
    const checked = event.target.checked
    const value = event.target.value

    // Sync all checkboxes with the same value (desktop and mobile)
    this.checkboxTargets.forEach(checkbox => {
      if (checkbox.value === value) {
        checkbox.checked = checked
      }
    })

    this.updateLabel()
  }
}
